var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
  height : _vm.height + 'px'
})},[_c('PinturaEditor',_vm._b({attrs:{"src":_vm.src,"imageWriter":_vm.imageWriter},on:{"pintura:process":function($event){return _vm.handleOverlayProcess($event)}}},'PinturaEditor',_vm.editorDefaults,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }